<div class="row">
    <div class="col-sm-6">
            <button type="button" class="btn-guardar" mat-raised-button (click)="verArchivo()" style="padding-left: 15px;" *ngIf="reglamentoInternoModel.tipo == 2 && reglamentoInternoModel.estado == 3">
                <i class="fas fa-print"></i> Descargar
            </button>
    </div>
</div>
<div class="customers">
    <div class="card" style="padding: 1rem;">
        <div class="card-body" style="padding: 20px;">
            
            <div class="row">
                <div class="d-flex justify-content-between">
                    <div>
                        <p style="text-align: left;
                            font: normal normal bold 26px/53px Montserrat;
                            letter-spacing: 0px;
                            color: #00B09E;
                            opacity: 1;">Reglamento Interno</p>
                    </div>
                    <div class="" style="text-align: left;">
                        <div class="d-flex justify-content-end" style="background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        ">
                            <p class="info-label">JARDÍN INFANTIL: </p>

                            <p class="info-data">{{dataJardin.jardin}}</p>

                            <p class="info-label">CÓDIGO: </p>

                            <p class="info-data">{{dataJardin.rbd}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-12 ">
                    <p style="font: normal normal 600 14px/18px Montserrat;
                    letter-spacing: 0px;
                    color: #30374B;
                    text-transform: uppercase;
                    display: inline-block;
                    opacity: 1;margin-bottom: 10px;">
                        NOTAS DE LA EDICIÓN:
                    </p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;margin-bottom: 3px;">La Directora/Encargada responsable de la formulación y actualización del Reglamento Interno correspondiente a su jardín infantil deberá completar con datos e información relativa a su establecimiento, siempre respetando los espacios asignados en este documento </p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;margin-bottom: 3px;">Así también, se ha considerado para el presente Reglamento Interno se utilice de manera inclusiva términos como “párvulos”, “educadoras”, “técnicos” para referirse a hombres y mujeres. Esta opción obedece a que no existe acuerdo sustantivo respecto de cómo aludir conjuntamente a ambos sexos en el idioma español, salvo usando “o/a”, “los/las” y otras similares, que contribuyen a una saturación lingüística que puede dificultar la comprensión de la propuesta.</p>
                    <p style="text-align: left;
                    letter-spacing: 0px;
                    color: #30374B;
                    opacity: 1;margin-bottom: 3px;">Las dudas que surjan sobre esto o sobre el contenido del reglamento, deben hacerse llegar a la Oficina de Reconocimiento Oficial de la Dirección Nacional, a través de sus contrapartes regionales.</p>
                </div>
            </div>
            <br>
            <div class="row  justify-content-end mb-2">
                <button type="button" (click)="imprimir()"  class="btn btn-light btn-send" *ngIf="reglamentoInternoModel.tipo === 1 && reglamentoInternoModel.estado != 3">IMPRIMIR</button>
               
                <!--button type="button" (click)="guardar()"  class="btn btn-light btn-send" *ngIf="reglamentoInternoModel.tipo === 1 && reglamentoInternoModel.estado != 3" >GUARDAR</button-->
                <!--button type="button" (click)="enviar()"  class="btn btn-light btn-send" *ngIf="reglamentoInternoModel.tipo === 1 && reglamentoInternoModel.estado != 3" >ENVIAR</button-->
                
            </div>

            <!--tiene que estar el tipo en en null y estado distinto de 3-->
            <!--subida unica-->
            <div *ngIf="parametroSubida === 1">
             
                <div class="row" *ngIf="reglamentoInternoModel.tipo === null">
                    <div class="div-obs" style="border: #84b2f5 1px solid;color: #FFF;background: #A0BFEC;text-align: justify;width: 100%;">
                        <div class="row">
                            <div class="col-sm-8 d-flex justify-content-center align-items-center">
                                <p>
                                    Favor selecciona una opción para cumplir con el Instrumento
                                </p>
                            </div>
                            <div class="col-sm-4 ">
                                <a class="btn-status" *ngIf="!simulacion" (click)="reglamentoInternoModel.tipo = 2" style="margin-bottom: 0px; border: #84b2f5 1px solid;margin-left: 25px;color: #A0BFEC;background: #FFF;text-align: center;width: 250px;display: inline-block;cursor: pointer; margin-top: 15px;" >
                                    Cargar Documento
                                </a>  
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row" *ngIf="reglamentoInternoModel.tipo === 2 && reglamentoInternoModel.estado != 3">
                        <div class="col-sm-12">
                            <div class="modal-body" style="padding: 0px 50px;" width="100%">
                                <div class="row">
                                    <div class="row row-form mt-3 mb-3">
                                        
                                        <div class="col-sm-6">
                                            <label>Archivo PDF</label>
                                        </div>
                                        <div class="col-sm-6">
                                            <input class="form-control" accept="application/pdf" type="file" #inputFile (change)="cambioArchivo($event)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div class="modal-footer">
                                <button type="button" class="btn btn-send mb-4" style="width: 180px;background-color: #597CEE; height: 38px;color: #FFFFFF;" (click)="subirArchivo($event)"> Enviar y Finalizar</button>
                            </div>
                        </div>
                </div>

            </div>  

            <!--subida multiple-->
            <div *ngIf="parametroSubida === 0">

                <div class="div-obs" style="border: #84b2f5 1px solid;color: #FFF;background: #A0BFEC;text-align: justify;width: 100%;">
                    <div class="row">
                        <div class="col-sm-8 d-flex justify-content-center align-items-center">
                            <p>
                                Favor selecciona una opción para cumplir con el Instrumento
                            </p>
                        </div>
                        <div class="col-sm-4 ">
                            <a class="btn-status" *ngIf="!simulacion" (click)="parametroMonstrarSubida = 1" style="margin-bottom: 0px; border: #84b2f5 1px solid;margin-left: 25px;color: #A0BFEC;background: #FFF;text-align: center;width: 250px;display: inline-block;cursor: pointer; margin-top: 15px;" >
                                Cargar Documento
                            </a>  
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="parametroMonstrarSubida === 1">
                
                    <div class="col-sm-12">
                        <div class="modal-body" style="padding: 0px 50px;" width="100%">
                            <div class="row">
                                <div class="row row-form mt-3 mb-3">
                                    
                                    <div class="col-sm-6">
                                        <label>Archivo PDF</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <input class="form-control" accept="application/pdf" type="file" #inputFile (change)="cambioArchivo($event)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="modal-footer">
                            <button type="button" class="btn btn-send mb-4" style="width: 180px;background-color: #597CEE; height: 38px;color: #FFFFFF;" (click)="subirArchivo($event)"> Enviar y Finalizar</button>
                        </div>
                    </div>
                </div>
            </div>  


            
            
            <div class="row" *ngIf="reglamentoInternoModel.tipo === 1 && reglamentoInternoModel.estado != 3">
                <div class="col-sm-12" >
                   <!-- ***************Inicio Datos Unidad Educativa***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-1" *ngIf="isCollapsed1" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">1</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-1"  *ngIf="!isCollapsed1" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">1</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Portada</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-1" style="margin: 10px;" *ngIf="isCollapsed1" alt="avatar" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-1" style="margin: 10px;" *ngIf="!isCollapsed1" alt="avatar" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse1="ngbCollapse" [(ngbCollapse)]="isCollapsed1">
                                            <div class="row">
                                               <!-- ******************************** -->
                                               <div class="customers">
                                                <div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="separator color-back-area-1"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                <div class="estrategia-text"><strong> </strong></div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="card">
                                                                <div class="card-body">
                                                    
                                                                    <div class="">
                                                    
                                                                        <table class="table-info">
                                                                            <tr>
                                                                                <td>
                                                                                    <p class="table-row-title">UNIDAD EDUCATIVA:</p>
                                                                                </td>
                                                                                <td>
                                                                                    {{reglamentoInternoModel.jardinPeriodo.jardin.jardin}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr class="table-tr-shadow">
                                                                                <td>
                                                                                    <p class="table-row-title">COMUNA:</p>
                                                                                </td>
                                                                                <td> {{reglamentoInternoModel.jardinPeriodo.comuna.nombre}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>
                                                                                    <p class="table-row-title">REGIÓN:</p>
                                                                                </td>
                                                                                <td> {{reglamentoInternoModel.jardinPeriodo.comuna.region.nombre}}</td>
                                                                            </tr>
                                                                            <tr class="table-tr-shadow">
                                                                                <td>
                                                                                    <p class="table-row-title">APROBADO:</p>
                                                                                </td>
                                                                                <td> {{reglamentoInternoModel.jardinPeriodo.directorEncargado}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>
                                                                                    <p class="table-row-title">FECHA ELABORACIÓN:</p>
                                                                                </td>
                                                                                <td>{{reglamentoInternoModel.fechaElavoracion | date:'dd/MM/yyyy'}}</td>
                                                                            </tr>
                                                                            <tr class="table-tr-shadow">
                                                                                <td>
                                                                                    <p class="table-row-title">FECHA MODIFICACIÓN:</p>
                                                                                </td>
                                                                                <td>{{reglamentoInternoModel.fechaActualizacion | date:'dd/MM/yyyy'}}</td>
                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- ***************Fin Datos Unidad Educativa***************** -->


                    <!-- ***************Inicio Diagnostico***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-2" *ngIf="isCollapsed2" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">2</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-2"  *ngIf="!isCollapsed2" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">2</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Identificación y Antecedentes del Jardín Infantil</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-2" style="margin: 10px;" *ngIf="isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-2" style="margin: 10px;" *ngIf="!isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">
                                            <div class="row">
                                                  <!-- ******************************** -->
                                               <div class="customers">
                                                <div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="separator color-back-area-2"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                <div class="estrategia-text"><strong> </strong></div>
                                                            </div>
                                                        </div>
                                                        <div class="row">

                                                            
                                                            <app-identificacion-antecedentes [jardinPeriodo]="reglamentoInternoModel.jardinPeriodo" [jardinExtraData]="reglamentoInternoModel.jardinExtraData" [readonly]="simulacion" ></app-identificacion-antecedentes>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************Fin Diagnostico***************** -->
                    
                    <!-- ***************Inicio Diagnostico***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-3" *ngIf="isCollapsed3" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">3</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-3"  *ngIf="!isCollapsed3" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">3</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Regulación sobre estructuras en niveles educativos y la trayectoria de los párvulos</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="!isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse3="ngbCollapse" [(ngbCollapse)]="isCollapsed3">
                                            <div class="row">
                                                 <!-- ******************************** -->
                                                 <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-3"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"><strong> </strong></div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <app-niveles-reglamento [estructuraNiveles]="reglamentoInternoModel.estructuraNiveles" [readonly]="simulacion" ></app-niveles-reglamento>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************Fin Diagnostico***************** -->

                    <!-- ***************Inicio Medios de comunicación***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-4" *ngIf="isCollapsed4" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">4</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-4"  *ngIf="!isCollapsed4" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">4</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Medios de comunicación correspondiente a la Unidad Educativa</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-4" style="margin: 10px;" *ngIf="isCollapsed4" alt="avatar" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-4" style="margin: 10px;" *ngIf="!isCollapsed4" alt="avatar" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse4="ngbCollapse" [(ngbCollapse)]="isCollapsed4">
                                            <div class="row">
                                                 <!-- ******************************** -->
                                                 <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-4"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"><p  style="margin: 10px;    text-align: left;
                                                                        font: normal normal bold 13px/20px Montserrat;
                                                                        letter-spacing: 0px;
                                                                        color: #fff;
                                                                        opacity: 1;">En el contexto del Protocolo de Actuación frente a la Vulneración de Derecho y en el Protocolo de Actuación frente a hechos de Maltrato Infantil, connotación sexual o agresiones sexuales, señale los medios de comunicación a las familias frente a un presunto maltrato infantil o vulneración de derecho (teléfono, correo electrónico, libreta de comunicaciones, otros).</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="row" style="padding: 20px;">
                                                                                                                                    </div>
                                                                <div class="row" style="padding: 20px;">
                                                                    <textarea class="text-area-consulta" name="mediosComunicacion" [(ngModel)]="reglamentoInternoModel.mediosComunicacion" [disabled]="simulacion"></textarea> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************Fin Medios de comunicación***************** -->

                    <!-- ***************Inicio Medios de comunicación***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-5" *ngIf="isCollapsed5" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">5</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-5"  *ngIf="!isCollapsed5" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">5</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Centros de salud para atención de Párvulos</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-5" style="margin: 10px;" *ngIf="isCollapsed5" alt="avatar" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-5" style="margin: 10px;" *ngIf="!isCollapsed5" alt="avatar" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse5="ngbCollapse" [(ngbCollapse)]="isCollapsed5">
                                            <div class="row">
                                                 <!-- ******************************** -->
                                                 <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-5 justify-content-end mb-2"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"><strong>  </strong></div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="row  justify-content-end mb-2">
                                                                    <button type="button" (click)="agregarcentroParbulo()"  class="btn btn-light btn-send" style="margin-top: 0px;" [disabled]="reglamentoInternoModel?.centroSaludParbulos?.length > 2 " *ngIf="!simulacion" >AGREGAR</button>
                                                                </div>
                                                                <div>
                                                                    <div class="row">
                                                                        <div class="col-sm-4">
                                                                            <p class="dataFecha" style="text-align: center;margin: 10px;">CENTRO DE SALUD PARA ATENCIÓN DE PÁRBULOS</p>
                                                                        </div>
                                                                        <div class="col-sm-4">
                                                                            <p class="dataFecha" style="text-align: center;margin: 10px;">DIRECCIÓN</p>
                                                                        </div>
                                                                        <div class="col-sm-4">
                                                                            <p class="dataFecha" style="text-align: center;margin: 10px;">COMUNA O LOCALIDAD</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-5" *ngFor="let centroSaludParbulosIt of reglamentoInternoModel?.centroSaludParbulos; let indice=index"> 
                                                                        <app-centros-salud-reglamento [centroSaludParbulos]="centroSaludParbulosIt" [readonly]="simulacion" ></app-centros-salud-reglamento>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************Fin Medios de comunicación***************** -->

                     <!-- ***************Inicio Institución denuncia***************** -->

                     <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-1" *ngIf="isCollapsed6" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">6</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-1"  *ngIf="!isCollapsed6" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">6</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Institución Denuncia</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-1" style="margin: 10px;" *ngIf="isCollapsed6" alt="avatar" (click)="collapse6.toggle()" [attr.aria-expanded]="!isCollapsed6" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-1" style="margin: 10px;" *ngIf="!isCollapsed6" alt="avatar" (click)="collapse6.toggle()" [attr.aria-expanded]="!isCollapsed6" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse6="ngbCollapse" [(ngbCollapse)]="isCollapsed6">
                                            <div class="row">
                                               <!-- ******************************** -->
                                               <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-1"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"> <p  style="margin: 10px;    text-align: left;
                                                                        font: normal normal bold 13px/20px Montserrat;
                                                                        letter-spacing: 0px;
                                                                        color: #fff;
                                                                        opacity: 1;">En el contexto del Protocolo de Actuación frente a hechos de Maltrato Infantil, connotación sexual o agresiones sexuales. Registrar donde se realizará la denuncia en caso de presunto maltrato infantil con carácter de delito.</p></div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <app-institucion-denuncia-reglamento [institucionDenuncia]="reglamentoInternoModel?.institucionDenuncia" [readonly]="simulacion"></app-institucion-denuncia-reglamento>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                               <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- ***************Fin Datos Unidad Educativa***************** -->

                   <!-- ***************Inicio Diagnostico***************** -->

                   <div class="customers">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="divDimension">
                                <div class="row">
                                    <div class="col-sm-1 color-back-area-2" *ngIf="isCollapsed7" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                    border-bottom-left-radius: 10px;color: antiquewhite;">
                                        <p style="padding: 20px;margin-left: 25px;font-weight: bold;">7</p>
                                    </div>
                                    <div class="col-sm-1 color-back-area-2"  *ngIf="!isCollapsed7" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                    color: antiquewhite;">
                                        <p style="padding: 20px;margin-left: 25px;font-weight: bold;">7</p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p class="dataFecha" style="margin: 20px;">Centros de Salud Cercano al Establecimiento</p>
                                    </div>
                                    <div class="col-sm-1 ">
                                        <button class="btn-collapser color-area-2" style="margin: 10px;" *ngIf="isCollapsed7" alt="avatar" (click)="collapse7.toggle()" [attr.aria-expanded]="!isCollapsed7" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                        <button class="btn-collapser color-area-2" style="margin: 10px;" *ngIf="!isCollapsed7" alt="avatar" (click)="collapse7.toggle()" [attr.aria-expanded]="!isCollapsed7" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                    </div>
                                    <div class="row " #collapse7="ngbCollapse" [(ngbCollapse)]="isCollapsed7">
                                        <div class="row">
                                             <!-- ******************************** -->
                                            <div class="customers">
                                                <div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="separator color-back-area-2"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                <div class="estrategia-text"> <p  style="margin: 10px;    text-align: left;
                                                                    font: normal normal bold 13px/20px Montserrat;
                                                                    letter-spacing: 0px;
                                                                    color: #fff;
                                                                    opacity: 1;">En el contexto del Protocolo de Actuación frente a hechos de Maltrato Infantil, connotación sexual o agresiones sexuales, en caso de un presunto maltrato infantil o vulneración de derecho debe registrar donde se constatará lesiones.   Además, se hace presente que, en el contexto del Protocolo de accidentes, en casos de accidentes de un niño o niña se debe registrar el centro de salud donde se va a llevar a los párvulos.</p></div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="row  justify-content-end mb-2">
                                                                <button type="button" (click)="agregarcentroCercano()"  class="btn btn-light btn-send" style="margin-top: 0px;" *ngIf="!simulacion">AGREGAR</button>
                                                            </div>
                                                            <div>
                                                                <div class="row">
                                                                    <div class="col-sm-4">
                                                                        <p class="dataFecha" style="text-align: center;margin: 10px;">NOMBRE</p>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <p class="dataFecha" style="text-align: center;margin: 10px;">DIRECCIÓN</p>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <p class="dataFecha" style="text-align: center;margin: 10px;">NÚMERO DE TELÉFONO</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row mb-5" *ngFor="let centroSaludCercanoIt of reglamentoInternoModel?.centroSaludCercano; let indice=index"> 
                                                                    <app-centros-salud-cercanos-reglamento [centroSaludCercano]="centroSaludCercanoIt" [readonly]="simulacion"></app-centros-salud-cercanos-reglamento>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        <!-- ******************************** -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ***************Fin Diagnostico***************** -->
                </div>
            </div>
            <br>
        </div>
    </div>
</div>



<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Reglamento Interno</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>



<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "default" color = "#fff" type = "line-spin-clockwise-fade" [fullScreen] = "true"><p style="color: white" > Cargando... </p></ngx-spinner>
